import { render, staticRenderFns } from "./Modaldle.vue?vue&type=template&id=7637f5b6&scoped=true&"
import script from "./Modaldle.vue?vue&type=script&lang=js&"
export * from "./Modaldle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637f5b6",
  null
  
)

export default component.exports